import React from "react";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from "../../components/common/toast";
import { FEATURE_MSG, COMMON_MSG, TOAST_TYPE } from "../../constants/toast";
import CommonModal from "../../components/common/commonModel";
import AddButtonSection from "../../components/common/AddButtonSection";

export default function PrescriptionDeleteConfirmation({
  visible,
  setVisible,
  medicalPrescription,
}) {
  const deletePrescriptionConfirmation = async () => {
    try {
      const response = await commonPostApi(
        API_ENDPOINTS.DELETE_MEDICINE,
        {
          medical_prescription_id: medicalPrescription,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.status === 200) {
        showToast(
          TOAST_TYPE.SUCCESS,
          FEATURE_MSG.EXAMINATION.PRESCRIPTION_DELETED
        );
        setVisible?.(false, true);
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
    } catch (error) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  };

  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Yes",
      class: "w-8rem pr-3",
      onClick: deletePrescriptionConfirmation,
    },
    {
      type: "secondaryButton",
      label: "No",
      class: "w-7rem",
      onClick: () => {
        setVisible?.(false);
      },
    },
  ];
  return (
    <div>
      <CommonModal
              visible={visible}
              header="Delete Prescription"
              onHide={() => setVisible(false)}
            >
              <div>
                <div className="flex justify-content-center pr-4">
                  Are you sure you want to delete this prescription?
                </div>
      
                <div className="mt-6 ml-2">
                  <AddButtonSection buttons={submitButtons} />
                </div>
              </div>
            </CommonModal>
    </div>
  )
}
